import { FeatureDTO } from "./FeatureDTO";

export class TermsOfUseFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
